import type { Item, ArticleQuoteType } from '../../types';

export const isArticleQuote = (item: Item): item is ArticleQuoteType => {
	return !!(item && item.__typename === 'Article_Quote');
};
